import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

const ANCHOR_LINKS = [
  { anchor: '#our-values', label: 'Our Values' },
  { anchor: '#our-people', label: 'Our People' },
  { anchor: '#open-roles', label: 'Open Roles' },
  { anchor: '#faq', label: 'FAQ' },
];

const StickyJobNavbar = () => (
  <Flex
    top="94"
    position="sticky"
    justifyContent="center"
    background="rgba(249, 252, 255, 0.97)"
    visibility={{ base: 'hidden', lg: 'initial' }}
    zIndex="10"
    px="5"
  >
    <Flex
      justifyContent="space-between"
      alignItems="center"
      maxW="4xl"
      w="100%"
      mx="auto"
      my="8"
    >
      {ANCHOR_LINKS.map(({ anchor, label }) => (
        <AnchorLink stripHash to={`/jobs/${anchor}`} key={anchor}>
          <Text fontWeight="bold" fontSize="xl">
            {label}
          </Text>
        </AnchorLink>
      ))}
    </Flex>
  </Flex>
);

export default StickyJobNavbar;
